export interface IBookmarksResponse {
  result: IBookmarksSummary[]
  hasMore: boolean
}

export interface IBookmarksSummary {
  id: string
  systemId: string
  title: string
  sourceUrl: string
  summaryTitle: string
  summaryUrl: string
  isDeleted: boolean
  createdOn: string
  updatedOn: string
  createdOnLong: string
}
export interface IBookmarksDeleteRequest {
  id: string
}

export class BookmarksDeleteRequest {
  id: string
}
export interface IBookmarksTable {
  size: number
  limit: number
}
export class BookmarksRequest {
  type: string
  title: string
  sourceUrl: string
  summaryTitle?: string
  summaryUrl?: string
}

export class BookmarksValues {
  id = ''
  systemId = ''
  title = ''
  sourceUrl = ''
  awardSummaryTitle = ''
  awardSummaryUrl = ''
}
